export const TRACK_EVENT_SCOPE = {
  COMMUNICATIONS: 'COMUNICADOS',
  CONVERSATIONS: 'CONVERSAS',
  MOMENTS: 'MOMENTOS',
  ENTITY_CONFIGURATION: 'CONFIGURACAO_DE_ENTIDADES',
};
